<div class="footer" *ngIf="(visibleTabs$ | async)?.length">
  <div class="footer__inner">
    <button
      type="button"
      class="footer-tab"
      *ngFor="let tab of visibleTabs$ | async; trackBy: trackByKey"
      [class.footer-tab--active]="tab.active"
      (click)="select(tab)"
    >
      <span class="footer-tab__icon-wrap" aria-hidden="true">
        <img
          class="footer-tab__icon"
          [src]="tab.icon"
          alt=""
          draggable="false"
        />
      </span>

      <span class="footer-tab__label">
        {{ tab.label | transloco }}
      </span>
    </button>
  </div>
</div>
